import { API_BASE_URL } from 'src/globals';
import { GET, POST } from './apiHandler';

export const fetchReportLayout = (reportKey: string) => GET(`${API_BASE_URL}/reporting/${reportKey}/layout`);

export const fetchReportChart = (reportKey: string, chartKey: string, filters: object) =>
  POST(`${API_BASE_URL}/reporting/${reportKey}/chart/${chartKey}`, filters);

// Full (export-capped) rows of a table chart for the Excel download: { columns, rows, truncated }.
export const exportReportChart = (reportKey: string, chartKey: string, filters: object) =>
  POST(`${API_BASE_URL}/reporting/${reportKey}/chart/${chartKey}/export`, filters);
